import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=1e83fdf2&scoped=true&"
import script from "./InformationCard.vue?vue&type=script&lang=ts&"
export * from "./InformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=1e83fdf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83fdf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VIcon,VLayout})
